import {
  graphql,
  useScrollRestoration,
  useStaticQuery,
  navigate,
} from "gatsby";
import React, {
  createRef,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useLocation } from "@reach/router";
import cn from "classnames";
const SelectGroups = ({ children, cards, postType, postCategory, term }) => {
  const query = useStaticQuery(graphql`
    query SelectGroups {
      wpPosts {
        tags {
          nodes {
            name
            slug
          }
        }
        categories {
          nodes {
            name
            slug
          }
        }

        allTaxonomies
      }

      wpPages {
        tags {
          nodes {
            name
            slug
          }
        }
        categories {
          nodes {
            name
            slug
          }
        }

        allTaxonomies
      }
    }
  `);
  //  const navigate = useNavigate()
  let allTaxes = undefined;
  let taxs = [];
  let radios = [];

  if (postType === "post" || postType === "lw_press") {
    allTaxes = JSON.parse(query.wpPosts.allTaxonomies);
    taxs = allTaxes[postType];
    taxs = Object.fromEntries(
      Object.entries(taxs).filter(([key, value]) => !!value.length)
    );
  } else if (postType === "resources") {
    allTaxes = JSON.parse(query.wpPages.allTaxonomies);
    radios = Object.values(allTaxes["resources"]["resource_type"]);
    if (term === "case-study") {
      const objs = Object.values(allTaxes["resources"]["resource"]);
      const parents = objs.filter((r) => !r.parent);
      taxs = parents.reduce((prev, cur) => {
        return {
          ...prev,
          [cur.slug]: objs.filter((r) => r.parent === cur.term_id),
        };
      }, {});
      if (taxs.industry) {
        delete taxs.industry;
      }
    }
  } else if (postType === "lw_partners") {
    allTaxes = JSON.parse(query.wpPages.allTaxonomies);
    const objs = Object.values(allTaxes["lw_partners"]["area"]);
    const parents = objs.filter((r) => !r.parent);
    taxs = parents.reduce((prev, cur) => {
      return {
        ...prev,
        [cur.slug]: objs.filter((r) => r.parent === cur.term_id),
      };
    }, {});
    radios = Object.values(allTaxes["lw_partners"]["categories"]);
  } else {
    allTaxes = JSON.parse(query.wpPages.allTaxonomies);
    taxs = allTaxes[postType];
    taxs = Object.fromEntries(
      Object.entries(taxs).filter(([key, value]) => !!value.length)
    );
  }
  // console.log("radios", radios);
  const { search } = useLocation();
  const terms = new URLSearchParams(search);
  const taxNames = Object.keys(taxs);
  const tax1Name = taxNames.length > 0 ? taxNames[0] : undefined;
  const tax2Name = taxNames.length > 1 ? taxNames[1] : undefined;
  const urlCats = terms.getAll(tax1Name);

  const tagCats = terms.getAll(tax2Name);

  const [selectedOne, setSelectedOne] = useState(urlCats);
  const [selectedTwo, setSelectedTwo] = useState(tagCats);
  const [selectedRadio, setSelectedRadio] = useState(undefined);
  const [openOne, setOpenOne] = useState(false);
  const [openTwo, setOpenTwo] = useState(false);

  useEffect(() => {
    function handleClick() {
      setOpenOne(false);
      setOpenTwo(false);
    }
    document.body.addEventListener("click", handleClick);
    return () => document.body.removeEventListener("click", handleClick);
  }, []);

  const ref = useRef();
  useEffect(() => {
    const searchTerms = new URLSearchParams();
    selectedOne.forEach((cat) => {
      searchTerms.append(tax1Name, cat);
    });

    selectedTwo.forEach((tag) => {
      searchTerms.append(tax2Name, tag);
    });
    //  navigate(`?${searchTerms.toString()}`);
  }, [selectedOne, selectedTwo]);

  const tax1 = taxs[Object.keys(taxs)[0]];
  const tax2 =
    Object.keys(taxs).length > 1 ? taxs[Object.keys(taxs)[1]] : undefined;

  let filteredCards = cards;

  if (tax1 && selectedOne.length > 0) {
    filteredCards = filteredCards.filter((card) => {
      if (card?.taxonomies) {
        return card.taxonomies.find((tag) => {
          return !!selectedOne.find((s) => s === tag.slug);
        });
      }
      return card?.terms?.find((cat) => {
        return !!selectedOne.find((s) => s === cat.slug);
      });
    });
  }
  if (tax2 && selectedTwo.length > 0) {
    filteredCards = filteredCards.filter((card) => {
      if (card?.acf?.tags) {
        return card.acf.tags.find((tag) => {
          return !!selectedTwo.find((s) => s === tag.slug);
        });
      }
      if (card?.taxonomies) {
        return card.taxonomies.find((tag) => {
          return !!selectedTwo.find((s) => s === tag.slug);
        });
      }
      return card?.terms?.find((tag) => {
        return !!selectedTwo.find((s) => s === tag.slug);
      });
    });
  }
  if (selectedRadio) {
    filteredCards = filteredCards.filter((card) => {
      if (postType === "resources") {
        return card.resourceType?.slug === selectedRadio;
      }
      if (card?.acf?.tags) {
        return card.acf.tags.find((tag) => {
          return tag.slug === selectedRadio;
        });
      }
      if (card?.taxonomies) {
        return card.taxonomies.find((tag) => {
          return tag.slug === selectedRadio;
        });
      }
      return card?.terms?.find((tag) => {
        return tag.slug === selectedRadio;
      });
    });
  }
  const getSelectedText = (selected) => {
    if (selected.length > 0) return ` (${selected.length})`;
    else return "";
  };

  const clearSelected = () => {
    setSelectedOne([]);
    setSelectedTwo([]);
  };

  return (
    <>
      {!!radios.length && (
        <div className="form-filter-pills">
          <input
            onClick={() => setSelectedRadio(undefined)}
            type="radio"
            id="radioAll"
            name="taxfilter1"
            value="all"
            defaultChecked={true}
          />
          <label for="radioAll">All</label>
          {radios.map((radio) => {
            return (
              <div className="radio-group" key={radio.slug}>
                <input
                  type="radio"
                  onClick={() => setSelectedRadio(radio.slug)}
                  id={radio.slug}
                  name="taxfilter1"
                  value={radio.term_id}
                />
                <label for={radio.slug}>{radio.name}</label>
              </div>
            );
          })}
        </div>
      )}
      {(tax1 || tax2) && (
        <div className="form-filter-select">
          <button type="button" className="button-open icon-close">
            Filter by:
          </button>
          <div className="form-filter-modal">
            <button type="button" className="button-close icon-close">
              Filter by:
            </button>

            <SelectGroup
              items={tax1.map((cat) => ({
                id: cat.slug,
                name: cat.name,
              }))}
              selected={selectedOne}
              setSelected={setSelectedOne}
              title={
                tax1Name.charAt(0).toUpperCase() +
                tax1Name.slice(1) +
                getSelectedText(selectedOne)
              }
              defaultSelected={urlCats}
              open={openOne}
              onOpen={(open) => {
                setOpenOne(open);
                setOpenTwo(false);
              }}
            />

            {tax2 && (
              <SelectGroup
                items={tax2.map((tag) => ({
                  id: tag.slug,
                  name: tag.name,
                }))}
                selected={selectedTwo}
                setSelected={setSelectedTwo}
                title={
                  (tax2Name === "tags"
                    ? "Topics"
                    : tax2Name.charAt(0).toUpperCase() + tax2Name.slice(1)) +
                  getSelectedText(selectedTwo)
                }
                defaultSelected={tagCats}
                open={openTwo}
                onOpen={(open) => {
                  setOpenOne(false);
                  setOpenTwo(open);
                }}
              />
            )}
          </div>
          <button
            onClick={() => clearSelected()}
            type="button"
            className={cn("filter-clear-all", {
              show: selectedTwo.length || selectedOne.length,
            })}
          >
            Clear all
            <span class="total-count">
              ({selectedTwo.length + selectedOne.length})
            </span>
          </button>
        </div>
      )}
      {children(filteredCards)}
    </>
  );
};

const SelectGroup = ({
  title,
  items,
  defaultSelected,
  setSelected,
  selected,
  open,
  onOpen,
}) => {
  const refs = useMemo(() => items.map(() => createRef()), []);

  useLayoutEffect(() => {
    if (selected.length === 0) {
      refs.forEach((ref) => {
        ref.current.checked = false;
      });
    }
  }, [selected]);

  return (
    <div
      className={cn("select-group", { open: open })}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        className="icon-chevron"
        onClick={(e) => {
          e.stopPropagation();
          onOpen(!open);
        }}
      >
        <span className="select-count">({selected.length})</span>
        {title}
      </button>
      <div className="select-group-options">
        <ul>
          {items.map((item, i) => (
            <li key={item.id}>
              <input
                type="checkbox"
                ref={refs[i]}
                onChange={(event) => {
                  const set = new Set(selected);
                  if (event.target.checked) {
                    set.add(item.id);
                  } else {
                    set.delete(item.id);
                  }
                  setSelected(Array.from(set));
                }}
                defaultChecked={!!defaultSelected.find((s) => s === item.id)}
                id={item.id}
                value={item.id}
              />
              <label htmlFor={item.id}>
                <span className="icon-check"></span>
                {item.name}
              </label>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
export default SelectGroups;
